import React, { Component } from 'react';
import Header from '../../components/header/Header';
import FormCliente from '../../components/FormCliente/FormCliente';
import { faTintSlash } from '@fortawesome/free-solid-svg-icons';



export default class LogCadastroCliente extends Component {


	state = {
		change: false,
		adress: {},
	}


	componentDidMount() {
		const objAdress = this.props.match.params.objAdress;
		if (objAdress) {
			this.setState({ adress: objAdress });
		}
	}


	handleChange = () => {
		this.setState({ change: !this.state.change });
	}


	render() {
		return (
			<div className="cadastroCliente" >
				<Header logado={false} where="cadastrocliente" changeAdress={this.state.change} />
				<FormCliente handleChange={this.handleChange} adress={this.state.adress} />
			</div>
		);
	}
}
